import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=6b4abaf0&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style1 from "./Info.vue?vue&type=style&index=1&id=6b4abaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4abaf0",
  null
  
)

export default component.exports